import { StageDef } from '../automationMachineInterfaces'
import { LINKEDIN_AUTOMATION_STAGE_STATUSES } from './linkedinAutomationStageStatuses'
import * as linkedinUrls from './linkedinUrls'
import { LinkedinSettingKey } from '../../recommendations/recommendationSettingsKeys'
import * as enums from '../../utils/enums'
import { getWaitForElementToAppearPromise } from '../interruptiblePromises'
import { evaluateXpath } from '../interruptibleXpath'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'

// Settings property functions
const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) => value)

const getIsFulfilledFn = (key) =>
  getIsFulfilledFnFromKey(key, (value) => value === 'On')

const getCantUndoFn = () => defaultCantUndoFn
const getIsDisabledFn = () => defaultIsDisabledFn
const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

enum StageKey {
  GATHER_SETTING_TWO_STEP_VERIFICATION = 'GATHER_SETTING_TWO_STEP_VERIFICATION',
}

async function getTwoStepVerificationSetting() {
  const twoStepVerificationSetting = await getWaitForElementToAppearPromise(
    document,
    () =>
      evaluateXpath<HTMLButtonElement>(
        document,
        `//div[contains(@aria-label, "two step verification")]`,
      )[0],
    5000,
  )

  return twoStepVerificationSetting?.textContent?.trim()
}

const gatherStageDefs: StageDef[] = [
  {
    type: enums.StageType.ACTION,
    key: StageKey.GATHER_SETTING_TWO_STEP_VERIFICATION,
    status: LINKEDIN_AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
    url: linkedinUrls.accountSignInSecurityUrl,
    action: async (machineContext, userContext) => {
      const { updateStoredInitialValues } = userContext

      const twoStepVerificationSetting = await getTwoStepVerificationSetting()

      await updateStoredInitialValues(
        {
          [LinkedinSettingKey.TWO_STEP_VERIFICATION]:
            twoStepVerificationSetting,
        },
        enums.LinkedinRecommendationKey.LINKEDIN_2FA,
      )
    },
  },
]

const updateStageDefs: StageDef[] = []
const undoStageDefs: StageDef[] = []

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
